// Top of a band page — only THE WALL (admin/magician) and the band signed in with its code see it: pick a show, jump into it.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ChevronDown, Headphones, Lock, SlidersHorizontal } from "lucide-react";
import { API } from "../../App";
import { hubAuth } from "./hubApi";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "../ui/dropdown-menu";

const signedIn = () => { const h = hubAuth().headers; return !!(h.Authorization || h["X-Band-Key"]); };

const ShowMenu = ({ label, icon: Icon, shows, href, testid, gold }) => (
  <DropdownMenu modal={false}>
    <DropdownMenuTrigger asChild>
      <button type="button" className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs sm:text-sm font-black transition-colors ${gold ? "bg-[#F2CC8F] text-[#080E14] hover:bg-[#F7DDB0]" : "bg-[#54E3FF] text-[#080E14] hover:bg-[#8CEEFF]"}`} data-testid={testid}>
        <Icon className="h-4 w-4" />{label}<ChevronDown className="h-3.5 w-3.5" />
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-80 max-w-[calc(100vw-2rem)] bg-[#0B131B] border-white/15 text-white" data-testid={`${testid}-list`}>
      <DropdownMenuLabel className="text-[10px] font-black uppercase tracking-[0.25em] text-white/45">Choose a show</DropdownMenuLabel>
      <DropdownMenuSeparator className="bg-white/10" />
      {shows.map((s) => (href(s) ? (
        <DropdownMenuItem key={s.item_id} asChild className="!items-start text-left cursor-pointer focus:bg-white/10 focus:text-white">
          <Link to={href(s)} className="flex flex-col gap-0.5 w-full no-underline" data-testid={`${testid}-item-${s.item_id}`}>
            <span className="text-sm font-bold text-white">{s.title}</span>
            <span className="text-[11px] text-white/50">{s.released ? "Released" : "In the edit"}</span>
          </Link>
        </DropdownMenuItem>
      ) : (
        <DropdownMenuItem key={s.item_id} disabled className="flex flex-col !items-start text-left gap-0.5" data-testid={`${testid}-item-${s.item_id}`}>
          <span className="text-sm font-bold">{s.title}</span>
          <span className="text-[11px]">No band link marked yet — mark one in the show's Band preview</span>
        </DropdownMenuItem>
      )))}
    </DropdownMenuContent>
  </DropdownMenu>
);

export const ShowStudioBar = ({ slug, name }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!signedIn()) return;
    axios.get(`${API}/bands/${slug}/studio-shows`, hubAuth()).then((r) => setD(r.data)).catch(() => setD(null));
  }, [slug]);
  if (!d?.shows?.length) return null;
  const admin = d.as === "admin";
  return (
    <div className="bg-[#080E14] border-b border-[#54E3FF]/25 text-white" data-testid="band-show-studio-bar">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-2.5 flex flex-wrap items-center gap-2">
        <span className="mr-auto inline-flex items-center gap-1.5 text-[10px] font-black uppercase tracking-[0.25em] text-white/45" data-testid="band-show-studio-who"><Lock className="h-3 w-3" />{admin ? "Only THE WALL sees this" : `Only ${name} sees this`}</span>
        {admin && <ShowMenu label="Show studio" icon={SlidersHorizontal} shows={d.shows} href={(s) => s.studio_url} testid="band-show-studio-menu" />}
        <ShowMenu label={admin ? "Band's private listen" : "Your private listen"} icon={Headphones} shows={d.shows} href={(s) => s.listen_url} testid="band-private-listen-menu" gold />
      </div>
    </div>
  );
};
